import { ModuleTypeEnum } from '../module';
import { TodayWidgetDefinition } from './widget';

export const FINANCE_WIDGETS: TodayWidgetDefinition[] = [
  {
    id: 'profit-loss',
    label: 'Revenue Overview',
    description: 'Weekly reservation, invoice, and collected revenue trends',
    moduleType: ModuleTypeEnum.ORGANIZATION,
    defaultColumn: 'revenue',
    allowedColumns: ['revenue', 'expenses', 'profit'],
    columnType: 'main',
    defaultSize: 'medium',
    isActive: false,
    icon: 'TrendingUp',
  },
]; 
